import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { Environment } from "src/app/models/api";
import { EnvironmentSelectByOptions } from "src/app/models/selectOptions";
import { ISelectionButton } from "../../selection-button/selection-button.component";

@Component({
    selector: "app-integration-environment",
    templateUrl: "./integration-environment.component.html",
    styleUrls: ["./integration-environment.component.scss"],
})
export class IntegrationEnvironmentComponent implements OnInit {
    @Input() public inAddMode: boolean;
    @Input() public environmentFormControl: FormControl<string>;

    public environmentSelectionButtons: BehaviorSubject<BehaviorSubject<ISelectionButton>[]> = new BehaviorSubject<
        BehaviorSubject<ISelectionButton>[]
    >([]);

    ngOnInit(): void {
        const environmentSelectionButtons: BehaviorSubject<ISelectionButton>[] = [];
        const selectedIndex = EnvironmentSelectByOptions.map((env) => env.id).indexOf(this.environmentFormControl.value);

        EnvironmentSelectByOptions.forEach((environment, index) => {
            const isSelected = selectedIndex === index;
            if (this.inAddMode || isSelected) {
                environmentSelectionButtons.push(
                    new BehaviorSubject<ISelectionButton>({
                        id: environment.id,
                        text: environment.displayName,
                        selected: isSelected ? true : false,
                    }),
                );
            }
        });
        this.environmentSelectionButtons.next(environmentSelectionButtons);
    }

    public onEnvironmentSelected(selectedButton: ISelectionButton) {
        this.environmentFormControl.setValue(<Environment>selectedButton.id);
    }
}
